import React, { Component } from 'react';
import { CCOButton, SectionHeader } from '../util/Components';
import EditEventView from '../ministry/events/EditEventView';
import EditSermonView from '../sermons/EditSermonView';
import EditAnnoucementView from '../ministry/announcements/EditAnnouncementView';
import EventPanelView from '../ministry/events/EventPanelView';
import AnnouncementPanelView from '../ministry/announcements/AnnouncementPanelView';
import SermonPanelView from '../sermons/SermonPanelView';
import Approval1PanelView from '../approvals/Approval1PanelView';
import Approval2PanelView from '../approvals/Approval2PanelView';
import Approval3PanelView from '../approvals/Approval3PanelView';
import Approval4PanelView from '../approvals/Approval4PanelView';
import ApproveUserPanelView from '../approvals/ApproveUserPanelView';
import EncouragementPanelView from '../encouragement/EncouragementPanelView';
import EventsWeekPanelView from '../overview/EventsWeekPanelView';
import BugPanelView from '../bugs/BugPanelView';
import PaymentsPanelView from '../financial/PaymentsPanelView';

const editComponents = {
  event: EditEventView,
  sermon: EditSermonView,
  announcement: EditAnnoucementView
};

const panelComponents = {
  event: EventPanelView,
  sermon: SermonPanelView,
  announcement: AnnouncementPanelView,
  approval1: Approval1PanelView,
  approval2: Approval2PanelView,
  approval3: Approval3PanelView,
  approval4: Approval4PanelView,
  encouragement: EncouragementPanelView,
  eventsWeek: EventsWeekPanelView,
  user_approval: ApproveUserPanelView,
  bugs: BugPanelView,
  payments: PaymentsPanelView
};

class PanelHolder extends Component {

  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      new: false
    };
  }

  componentWillMount() {
    this.currentlyLoaded = 0;
    this.fetchObjects(this.props, 10);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.type !== this.props.type || newProps.fetch !== this.props.fetch) {
      this.currentlyLoaded = 0;
      this.fetchObjects(newProps, 10);
    }
  }

  fetchObjects(props, limit) {
    this.currentlyLoaded = limit;

    props.fetchObjects(limit, data => {
      console.log("got data");
      console.log(JSON.stringify(data));
      if (Array.isArray(data))
        this.setState({objects: data});
      else if (typeof data === "object")
        this.setState({objects: Object.keys(data).map(key => data[key])})
    });
  }

  loadMore() {
    this.fetchObjects(this.props, this.currentlyLoaded + 10);
  }

  render() {

    var views = [];

    var PanelView = panelComponents[this.props.type];

    let objects = this.state.objects;

    if (objects != null && this.state.objects.length !== 0) {

      // if (this.props.sortFunc) {
      //   objects = objects.sort(this.props.sortFunc);
      //   console.log("sorting");
      // }

      let sortFunc = this.props.sortFunc || function () { return true };
      //console.log(objects);

      if (this.props.sections && objects) {
        this.props.sections.forEach(function(item, i) {
          //console.log(item.filter);
          if (objects.filter(item.filter).length > 0) {
            views.push(<SectionHeader key={i} title={item.title} />);
            views = views.concat(objects.filter(item.filter).sort(sortFunc).map(object => {
              return <PanelView key={object.key} objectPass={object} {...this.props} />;
            }));
          }
        }.bind(this));
      }
      else {
        views = objects.sort(sortFunc).map(object => {
          return <PanelView key={object.key} objectPass={object} {...this.props} />;
        });
      }
    }

    var style = {
      padding: 20,
      paddingTop: 5
    };

    if (this.props.side) {
      style.marginLeft = 170;
    }

    var NewView = editComponents[this.props.type];

    var emojiSupported = (String.fromCodePoint !== undefined);
    var emptyText = "Nothing to see here " + (emojiSupported ? String.fromCodePoint('0x1F47D') : "");
    if (this.props.approval) {
      emptyText = "All Done! Nice Job " + (emojiSupported ? String.fromCodePoint('0x1F44D') : "");
    } else if (this.props.new) {
      emptyText = "Nothing yet, start by pressing the New button above!";
    }

    return (
      <div style={style}>
        {NewView && <NewView done={() => this.setState({new: false})} show={this.state.new} new {...this.props} />}
        <center>
          {this.props.addable && <div>
            <div style={{maxWidth: 500}}>
              <CCOButton text={"New " + this.props.type.capitalizeFirstLetter()} onClick={() => this.setState({new: true})} type="primary" />
            </div>
          </div>}
          {!this.props.sections && <div style={{height: 20}} />}
          {views}
          <div style={{height: 10}} />
          {views.length === 0 && <p style={{color: 'gray'}}>{emptyText}</p>}
          {this.state.objects != null && this.currentlyLoaded === this.state.objects.length && this.state.objects.length > 0 && <button className="blueButton" onClick={this.loadMore.bind(this)}>Load More</button>}
        </center>
      </div>
    );
  }
}

export default PanelHolder;



/** WEBPACK FOOTER **
 ** ./src/model/PanelHolder.js
 **/